type IconProps = {
  className?: string;
  height?: string | number;
  width?: string | number;
  fill?: string;
};

const DuplicateLiteIcon = ({
  width = 16,
  height = 16,
  className = "",
  fill = "currentColor",
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    test-id="UO-22LFT"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.14364 1.66602C6.15129 1.66602 5.34683 2.41533 5.34683 3.33965V4.00707H6.88428V3.33965C6.88428 3.20623 7.0004 3.09807 7.14364 3.09807H16.5366C16.6798 3.09807 16.796 3.20623 16.796 3.33965V13.6121C16.796 13.7456 16.6798 13.8537 16.5366 13.8537H15.9291V15.2858H16.5366C17.529 15.2858 18.3334 14.5365 18.3334 13.6121V3.33965C18.3334 2.41533 17.529 1.66602 16.5366 1.66602H7.14364ZM3.46356 5.47467C2.47121 5.47467 1.66675 6.22398 1.66675 7.1483V16.6591C1.66675 17.5834 2.47121 18.3327 3.46356 18.3327H12.8565C13.8489 18.3327 14.6533 17.5834 14.6533 16.6591V7.1483C14.6533 6.22398 13.8489 5.47467 12.8565 5.47467H3.46356ZM3.2042 7.1483C3.2042 7.01488 3.32032 6.90672 3.46356 6.90672H12.8565C12.9998 6.90672 13.1159 7.01488 13.1159 7.1483V16.6591C13.1159 16.7925 12.9998 16.9006 12.8565 16.9006H3.46356C3.32032 16.9006 3.2042 16.7925 3.2042 16.6591V7.1483Z"
      fill={fill}
      test-id="vdUdq9Oo"
    />
  </svg>
);

export default DuplicateLiteIcon;
